import React from 'react'

interface Props {
	max: number
	current: number
}

export const Progress: React.FC<Props> = ({ max, current }) => {
	const percent = Math.min((current / max) * 100, 100)
	return (
		<div className="h-px-2 bg-green-100">
			<div className="bg-green h-px-2" style={{ width: `${percent}%` }} />
		</div>
	)
}
